import axios from 'axios';
import { authBaseUrl } from '../../util/constants';

export default async function logout(): Promise<void> {
  await axios.put(`${authBaseUrl}/logout`, undefined, {
    withCredentials: true,
  });
}
